var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['flex', 'items-center', _vm.disabled ? 'cursor-not-allowed' : 'cursor-pointer', 'group', 'outline-none'],attrs:{"role":"checkbox","aria-checked":String(_vm.value),"aria-disabled":_vm.disabled,"tabindex":"0"},on:{"click":_setup.onChange,"keypress":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"]))return null;$event.stopPropagation();return _setup.onChange.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.stopPropagation();return _setup.onChange.apply(null, arguments)}]}},[_c('span',{class:[
      'transition-colors',
      'w-[21px] h-[21px] my-[-0.5px] rounded box-border',
      'relative flex items-center justify-center',
      _vm.disabled ? 'cursor-not-allowed' : 'cursor-pointer',
      // Border
      'hover-hover:group-focus-visible:border-2 hover-hover:group-focus-visible:border-solid',
      {
        'border-grape-500': _vm.darkMode === false,
        'border-canary-500': _vm.darkMode === true,
        'border-grape-500 dark:border-canary-500': _vm.darkMode === 'auto',
      },
    ]},[(!_vm.value)?_c('svg',{class:[
        !_vm.disabled && {
          'text-dark-text-300': _vm.darkMode === false,
          'text-light-text-300': _vm.darkMode === true,
          'text-dark-text-300 dark:text-light-text-300': _vm.darkMode === 'auto',
        },
        _vm.disabled && _setup.disabledTextClasses,
      ],attrs:{"width":"16","height":"16","viewBox":_setup.viewBox,"fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3 0.5C1.62915 0.5 0.5 1.62915 0.5 3V13C0.5 14.3708 1.62915 15.5 3 15.5H13C14.3708 15.5 15.5 14.3708 15.5 13V3C15.5 1.62915 14.3708 0.5 13 0.5H3ZM3 2.16667H13C13.47 2.16667 13.8333 2.53001 13.8333 3V13C13.8333 13.47 13.47 13.8333 13 13.8333H3C2.53001 13.8333 2.16667 13.47 2.16667 13V3C2.16667 2.53001 2.53001 2.16667 3 2.16667Z","fill":"currentColor"}})]):_c('svg',{class:[
        'transition-colors',
        !_vm.disabled && [
          {
            'text-grape-500': _vm.darkMode === false,
            'text-canary-500': _vm.darkMode === true,
            'text-grape-500 dark:text-canary-500': _vm.darkMode === 'auto',
          },
          {
            // We use `grape-500` with a 90% opacity.
            'hover-hover:group-hover:text-[rgba(148,102,232,0.9)]': _vm.darkMode === false,
            'hover-hover:group-hover:text-canary-600': _vm.darkMode === true,
            'hover-hover:group-hover:text-[rgba(148,102,232,0.9)] hover-hover:dark:group-hover:text-canary-600':
              _vm.darkMode === 'auto',
          },
        ],
        _vm.disabled && _setup.disabledSvgClasses,
      ],attrs:{"width":"16","height":"16","viewBox":_setup.viewBox,"fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13.2083 0.5H2.79167C1.52833 0.5 0.5 1.52833 0.5 2.79167V13.2083C0.5 14.4717 1.52833 15.5 2.79167 15.5H13.2083C14.4717 15.5 15.5 14.4717 15.5 13.2083V2.79167C15.5 1.52833 14.4717 0.5 13.2083 0.5ZM12.8171 5.73375L6.98375 11.5671C6.86167 11.6892 6.70167 11.75 6.54167 11.75C6.38167 11.75 6.22167 11.6892 6.09958 11.5671L3.59958 9.06708C3.35542 8.82292 3.35542 8.4275 3.59958 8.18333C3.84375 7.93917 4.23917 7.93917 4.48333 8.18333L6.54125 10.2413L11.9325 4.85C12.1767 4.60583 12.5721 4.60583 12.8162 4.85C13.0604 5.09417 13.0608 5.48958 12.8171 5.73375Z","fill":"currentColor"}})])]),_vm._v(" "),(_vm.label)?_c('span',{class:[
      'font-sans text-body-extra-small ms-0.5 select-none',
      !_vm.disabled && [
        _vm.value
          ? {
              'text-dark-text-100': _vm.darkMode === false,
              'text-light-text-100': _vm.darkMode === true,
              'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
            }
          : [
              // Base
              {
                'text-dark-text-200': _vm.darkMode === false,
                'text-light-text-200': _vm.darkMode === true,
                'text-dark-text-200 dark:text-light-text-200': _vm.darkMode === 'auto',
              },
              // Hover
              {
                'hover-hover:group-hover:text-dark-text-100': _vm.darkMode === false,
                'hover-hover:group-hover:text-light-text-100': _vm.darkMode === true,
                'hover-hover:group-hover:text-dark-text-100 hover-hover:dark:group-hover:text-light-text-100':
                  _vm.darkMode === 'auto',
              },
            ],
      ],
      _vm.disabled && _setup.disabledTextClasses,
    ]},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }